import axiosInstance from "../../../../../api/axiosInstance";

export async function getTaxConfigs(businessId) {
  const { data } = await axiosInstance.get("/store_settings/taxes", {
    params: { business_id: businessId },
  });
  return data || { taxConfigs: [] };
}

/**
 * Save tax configs in batch.
 * Expects/forwards server response:
 *   { ok: boolean, idMap?: { [client_id]: server_id }, taxConfigs?: [...] }
 * so the client can map temporary config ids used in assignments.
 */
export async function saveTaxConfigs(businessId, payload) {
  const { data } = await axiosInstance.post("/store_settings/taxes/save", payload, {
    params: { business_id: businessId },
  });
  return data || { ok: true, idMap: {} };
}

export async function getTaxAssignments(businessId) {
  const { data } = await axiosInstance.get("/store_settings/taxes/assignments", {
    params: { business_id: businessId },
  });
  return data || { assignments: {} };
}

export async function saveTaxAssignments(businessId, payload) {
  // payload: { assignments: { [taxId]: productId[] } }
  await axiosInstance.put("/store_settings/taxes/assignments", payload, {
    params: { business_id: businessId },
  });
  return true;
}
